import React from "react";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index.es.js";  // This import only works for FA v6.7.2 + react-fontawesome@0.1.18. 
import { faStar as faStarLight } from "@fortawesome/pro-light-svg-icons"
import { faStar as faStarSolid } from "@fortawesome/pro-solid-svg-icons"

const RecipeRatingStar = ({ recipeId, rating, updateRating, cat }) => {
  let ratingDecrement = rating;

  let onClick = (ratingSelected) => {
    const ratingUpdated = ratingSelected + 1;
    updateRating(recipeId, ratingUpdated, cat);
  };

  return (
    <div className="rating-box">
      {_.times(5, function (i) {
        const isRated = ratingDecrement > 0 ? true : false;
        // const ratingFas = isRated ? "fas" : "far";
        ratingDecrement--;
        return (
          <a
            className={isRated ? "rating rated" : "rating unrated"}
            onClick={() => onClick(i)}
          >
            {/* <i
              className={`fa-star ${ratingFas}`}
              style={{
                color: isRated ? "#ffd700" : "#aaa",
              }}
            /> */}
            <FontAwesomeIcon
              icon={isRated ? faStarSolid : faStarLight}
              style={{ color: isRated ? "#ffd700" : "#aaa" }}
            />
          </a>
        );
      })}
    </div>
  );
};

export default RecipeRatingStar;



// WEBPACK FOOTER //
// ./src/components/RecipeRatingStar.js